import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.375 12C6.375 11.7929 6.52314 11.625 6.70588 11.625L17.2941 11.625C17.4769 11.625 17.625 11.7929 17.625 12C17.625 12.2071 17.4769 12.375 17.2941 12.375L6.70588 12.375C6.52314 12.375 6.375 12.2071 6.375 12Z",
		fill: "currentColor"
	})
});
export default SvgMinus;
